import React, { useState } from "react"
import useApi from 'hooks/useApi'
import { TextArea, Button, Avatar } from '@arnsbogroup/react-voicearchive'
import messages from "./messages"
import { useIntl, FormattedDate, FormattedTime, FormattedMessage } from 'react-intl'
import useCurrentUser from 'hooks/useCurrentUser'

const Comments = ({ orderId }) => {
  const { roles } = useCurrentUser()
  const { formatMessage } = useIntl()
  const [newComment, setNewComment] = useState('')
  const [addComment, setAddComment] = useState(false)
  const [loading, setLoading] = useState(false)
  const [comments,,, refetch] = useApi(`/rest/v2/order/${orderId}/audition-scope-comment`)

  const saveComment = () => {
    setLoading(true)
    fetch(`/rest/v2/order/${orderId}/audition-scope-comment`, {
      credentials: 'same-origin',
      method: 'POST',
      body: JSON.stringify({comment: newComment})
    })
    .then((response) => response.json())
    .then(({success, errors}) => {
      if (success) {
        toastr.success("Comment added")
        setAddComment(false)
        setNewComment('')
      } else {
        toastr.error(errors.join(','))
      }
      setLoading(false)
      refetch()
    })
    .catch((error) => {
      toastr.error(error)
    })
  }

  if (!comments) {
    return null
  }

  return (
    <div className="w-full p-2">
      <div>
        <ul role="list" className="p-2">
          {comments.map((comment, index) => (
            <li key={comment.crdate}>
              <div className="relative pb-3 2xl:pb-6">
                {index !== comments.length - 1 ? (
                  <span
                    className="absolute top-3 left-3 -ml-px h-full w-0.5 bg-gray-200"
                    aria-hidden="true"
                  />
                ) : null}
                <div className="relative flex space-x-3">
                  <div>
                    <Avatar
                      size="xs"
                      src={comment.image}
                      title={comment.name}
                      initials={comment.name?.match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase()}
                    />
                  </div>
                  <div className='2xl:flex 2xl:space-x-4 min-w-0 flex-1 justify-between pt-1.5 text-sm'>
                    <p className="whitespace-pre-wrap">
                      { comment.message }
                    </p>
                    <div className="whitespace-nowrap text-xs 2xl:text-sm 2xl:text-right">
                      { comment?.crdate &&
                        <div className="gap-2 flex flex-col-2">
                          <div className="text-xs">
                            <FormattedDate value={new Date(comment.crdate * 1000)} />
                          </div>
                          <div className="text-xs">
                            <FormattedTime value={new Date(comment.crdate * 1000)} />
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
      {!addComment ? (
        <Button
          size="xs"
          onClick={() => setAddComment(true)}
        >
          <FormattedMessage {...messages.addComment} />
        </Button>
      ) : (
        <div className="w-full">
          <div>
            <TextArea
              label={formatMessage(messages.commentLabel)}
              description={(roles.includes('coordinator') || roles.includes('sales')) ?
                formatMessage(messages.coordinatorDescription) :
                formatMessage(messages.customerDescription)
              }
              rows={6}
              onChange={({ target: { value } }) => setNewComment(value)}
              value={newComment}
            />
          </div>
          <div className="text-right">
            <div className="flex flex-col-2 gap-2 justify-end">
              <Button disabled={!newComment} size="sm" className="h-10 mt-4" onClick={() => saveComment()}>
                { loading ? <FormattedMessage {...messages.loading} /> : <FormattedMessage {...messages.saveComment} /> }
              </Button>
              <Button state="negative" variant="outline" size="sm" className="h-10 mt-4" onClick={() => setAddComment(false)}>
                <FormattedMessage {...messages.cancel} />
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Comments
